import styled from 'styled-components';

import { colors, cssBreakpoints } from 'theme/theme';

const buttonBarHeight = '67px';

export const ButtonBarContainer = styled.div`
  min-height: ${buttonBarHeight};
  z-index: 3;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const ButtonBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  position: fixed;
  min-height: ${buttonBarHeight};
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: ${colors.white};
  box-shadow: 0 -3px 4px 1px rgba(0, 0, 0, 0.15);
  & > button,
  & > a {
    &:first-child {
      margin-left: 16px;
    }
    margin-right: 16px;
  }
`;
